import { alertAnatomy as parts } from "@chakra-ui/anatomy";

const baseStyle = () => ({
  container: {
    alignItems: "flex-start",
    borderStyle: "solid",
    borderRadius: "4px",
    borderWidth: "1px",
  },
  description: {},
  icon: {},
  title: {},
});

const variants = {
  "left-accent": ({ colorScheme }) => ({
    container: {
      borderColor: `${colorScheme}.300`,
      borderInlineStartColor: `${colorScheme}.300`,
    },
    description: {},
    icon: {},
    title: {},
  }),
  solid: ({ colorScheme }) => ({
    container: {
      borderColor: `${colorScheme}.500`,
    },
    description: {},
    icon: {},
    title: {},
  }),
  subtle: ({ colorScheme }) => ({
    container: {
      borderColor: `${colorScheme}.200`,
    },
    description: {},
    icon: {},
    title: {},
  }),
  "top-accent": ({ colorScheme }) => ({
    container: {
      borderColor: `${colorScheme}.300`,
      borderTopColor: `${colorScheme}.300`,
    },
    description: {},
    icon: {},
    title: {},
  }),
};

const defaultProps = {};

export default {
  parts: parts.keys,
  baseStyle,
  defaultProps,
  variants,
};
